<template>

  <div :class="{'actions-bar': true, full: full, 'full-menu': fullMenu}">

    <slot></slot>

  </div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ActionsBar',
  props: {
    full: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState('general',['fullMenu']),
  },
  data() {
  	return {
  	  
  	}
  },
  methods: {


  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_settings.less';
@import './../../assets/css/less/_helper.less';
.actions-bar {

  position: fixed;
  background-color:rgba(255,255,255,0.5);
  bottom: 0;
  left: 0;
  width: 100%;
  padding:10px 10px 0 24px;
  z-index: 99;
  .action-button {
    background-color: @formDefaultColour;
    color: #fff;
    display: inline-block;
    .rounded(4px);
    font-size: 14px;
    cursor: pointer;
    margin: 0 6px 10px 0;
    padding: 2px 6px;
    &:hover {
      color: @formDefaultColour;
      background-color: #fff;
    }
    &.right {
      float: right;
    }
  }
}
@media screen and (min-width: 768px) {
  .actions-bar {

    &.full {

      left: 66px;

      &.full-menu {

        width: ~"calc( 100% - @{fullMenuWidth} )";
        left: @fullMenuWidth;

      }

    }

  }
}
</style>